export default __webpack_public_path__ + "static/media/rewards_icon_leisure.693d1265.svg";